import { Play, Image as ImageIcon } from "lucide-react";

interface ThumbnailWithPlaceholderProps {
  src?: string | null;
  alt: string;
  /** Normalized format; anything matching "video" (case-insensitive) shows a play icon. */
  format?: string | null;
  /** Tailwind classes controlling the outer sizing/shape. */
  className?: string;
  /** Optional inline style (e.g. `{ aspectRatio: "4/5" }`). */
  style?: React.CSSProperties;
  /** Icon size — matches lucide's w-X h-X classes. Default `w-8 h-8`. */
  iconClass?: string;
}

export const ThumbnailWithPlaceholder = ({
  src,
  alt,
  format,
  className = "",
  style,
  iconClass = "w-8 h-8",
}: ThumbnailWithPlaceholderProps) => {
  const isVideo = (format ?? "").toLowerCase() === "video";

  return (
    <div className={`bg-gray-100 overflow-hidden ${className}`} style={style}>
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" loading="lazy" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-gray-300">
          {isVideo ? <Play className={iconClass} /> : <ImageIcon className={iconClass} />}
        </div>
      )}
    </div>
  );
};

export default ThumbnailWithPlaceholder;
